import { defineComponent as _defineComponent } from 'vue'
import VersionAlert from 'ah-common-lib/src/common/components/VersionAlert.vue';
import { config } from './config';
import MaintenanceWarningScreen from 'bd-common/src/components/common/MaintenanceWarningScreen.vue';
import { useAuthStore } from 'bd-common/src/store/authStore';
import { computed, onMounted, ref, watch } from 'vue';
import { useTheme } from 'ah-theme';

/**
 * Main App component
 *
 * This component serves 2 functions:
 * - Displays the maintenance screen if either the app is in maintenance OR the app theme has failed to load
 * - Re-checks for theme until it loads properly
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const CHECK_THEME_LOAD_TIMEOUT = 3000;

const pageLoaded = ref(false);

const authStore = useAuthStore();

const theme = useTheme();

let checkLoadThemeTimeout: number | null = null;

onMounted(() => {
  window.setTimeout(() => {
    pageLoaded.value = true;
  });
});

const showDevTools = computed(() => !!config.showDevTools);

const themeLoaded = computed(() => theme.loaded || theme.error);

function checkLoadTheme() {
  if (checkLoadThemeTimeout) {
    clearTimeout(checkLoadThemeTimeout);
  }
  if (!theme.loaded && !authStore.isInMaintenance) {
    theme.load().subscribe({
      error: () => {
        checkLoadThemeTimeout = window.setTimeout(() => checkLoadTheme(), CHECK_THEME_LOAD_TIMEOUT);
      },
    });
  }
}

watch(() => authStore.isInMaintenance, checkLoadTheme);

return { __sfc: true,CHECK_THEME_LOAD_TIMEOUT, pageLoaded, authStore, theme, checkLoadThemeTimeout, showDevTools, themeLoaded, checkLoadTheme, VersionAlert, MaintenanceWarningScreen }
}

})